import Container from "@client/content/Containers/container";
import TableView from "@client/content/controls/TableView/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Badge from "@client/controls/Badge/component";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import DetailModal from "./DetailModal/container";
import NewTicketModal from "./NewTicketModal/container";
import { getTicketStatusBadgeType } from "./lib";
import { type MemberHelpdesk } from "./types";

import "./style.less";

export type MapProps = RootContainerProps & {
  canAdd: boolean;
  tickets: MemberHelpdesk.Ticket[];
  status: string;
  userId: number | null;
};

export interface ActionProps {
  onAddClick: () => void;
  onItemClick: (item: MemberHelpdesk.Ticket) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container {...getContainerProps(props)} className="wsc_content_member_helpdesk">
      {props.userId ? (
        <>
          <TableView
            {...getRootContainerProps(props)}
            idKey="ticketId"
            isLoading={props.status === Status.Loading}
            columns={[
              {
                key: "subject",
                name: i18n.subject,
                dataType: "string",
                data: (x) => (x.contactHasRead ? x.subject : <strong>{x.subject}</strong>),
                width: "50%"
              },
              {
                key: "lastModifiedOnDate",
                name: i18n.lastModified,
                dataType: "dateTime",
                width: "30%"
              },
              {
                align: "right",
                key: "ticketStatusKey",
                name: i18n.status,
                dataType: "string",
                data: (x) => <Badge color={getTicketStatusBadgeType(x.ticketStatusKey)}>{x.ticketStatusName}</Badge>,
                width: "20%"
              }
            ]}
            data={props.tickets}
            noDataText={i18n.infoNoTickets}
            add={{
              label: i18n.submitATicket,
              onClick: props.onAddClick,
              isDisabled: !props.canAdd
            }}
            onRowClick={props.onItemClick}
            itemMenu={null}
            pageSize={20}
          />

          <DetailModal {...getRootContainerProps(props)} />
          <NewTicketModal {...getRootContainerProps(props)} />
        </>
      ) : (
        <div>{i18n.infoNoAccess}</div>
      )}
    </Container>
  );
};
